import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import StopLossContractDetail from './detail';
import { useForm, FormProvider } from 'react-hook-form';
import StopLossContractModification from './slcModification';
import SubmitButton from 'common/SingleClickButton';

const StopLossContractDetailDialog = (props) => {
  const { onClose, open, tenantId, target } = props;

  const methods = useForm({ defaultValues: { ...target }, mode: 'onBlur' });
  const { reset } = methods;

  const handleClose = (data) => {
    onClose(data);
  };

  const onSubmit = (data) => {
    onClose(data);
  };

  useEffect(() => {
    reset({ ...target });
  }, [tenantId, open, target]);

  return (
    <>
      <FormProvider {...methods}>
        <Dialog
          maxWidth="lg"
          open={open}
          onClose={(_, reason) => {
            if (reason !== 'backdropClick') {
              handleClose();
            }
          }}>
          <DialogTitle id="customized-dialog-title">
            {target && target.id > 0 ? 'Edit' : 'New'}
          </DialogTitle>
          <DialogContent dividers>
            {target && target.id > 0 ? (
              <StopLossContractModification
                tenantId={tenantId}
                targetId={target.id}
                hasAsl={
                  target &&
                  Array.isArray(target.aggRates) &&
                  target.aggRates.length > 0
                    ? true
                    : false
                }
              />
            ) : (
              <StopLossContractDetail
                tenantId={tenantId}
                isModified={target && target.id > 0}
                targetId={target ? target.id : null}
              />
            )}
          </DialogContent>
          <DialogActions>
            <SubmitButton
              handleSubmit={methods.handleSubmit(onSubmit)}
              isDirty={methods.formState.isDirty}
            />
            <Button onClick={() => handleClose(null)} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default StopLossContractDetailDialog;
